import { render, staticRenderFns } from "./hand-thumbs-up.vue?vue&type=template&id=11e2e22b&"
import script from "./hand-thumbs-up.vue?vue&type=script&lang=js&"
export * from "./hand-thumbs-up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports